import React, { useState } from 'react';
import { SlidingScale } from '../../survey-tools/likert-scales';
import { Button, Typography } from "@mui/material";
import { connect } from 'react-redux';
import { nextTask } from '../../study-logic/study-redux-slice';
import {PageContainer} from "../../survey-tools/ui-components/containers"
import {CustomConfirmationDialog} from '../../survey-tools/custom-dialogue'; // Adjust the import path as needed

function SocImpactScale({ instanceId,nextTask }) {
    const [sliderValue, setSliderValue] = useState(50);
    const [sliderMoved, setSliderMoved] = useState(false); // State to track if the slider has been moved
    const [showDialog, setShowDialog] = useState(false);

    const handleChange = (newValue) => {
        if (!sliderMoved) setSliderMoved(true); // Update sliderMoved to true on first interaction
        setSliderValue(newValue);
    };

    const handleNext = () => {
        if (!sliderMoved) { // Check if the slider has never been moved
            setShowDialog(true); // Show the dialog if the slider hasn't been moved
        } else {
            console.log("Saving Social Impact Value:", sliderValue);
            console.log("Instance ID:", instanceId);
            nextTask({ data: { [instanceId]: sliderValue } });
        }
    };
    const question = (
        <div>
            <Typography gutterBottom>
                On a scale from 0-100, indicate the <strong>Social Impact</strong> of your current state, where 0 is low social impact and 100 is high social impact.
            </Typography>
            <Typography gutterBottom style={{ marginTop: '1em' }}>
                <strong>Low Social Impact</strong> refers to states that are NOT likely to affect anybody beyond the person experiencing the state because they are not at all intense or a type of state not directed towards other people.
            </Typography>
                        <div style={{ height: '10px' }}></div> 

            <Typography gutterBottom>
                <strong>High Social Impact</strong> refers to states that are likely to affect people beyond the person experiencing the state because they are very intense or a type of state inherently directed towards other people.
            </Typography>
            <Typography gutterBottom style={{ marginTop: '1em' }}>
                For example, states that are <strong>low social impact</strong> are <strong>tiredness, boredom, loneliness,</strong> and <strong>gloominess</strong>, while states that are <strong>high social impact</strong> are <strong>excitement, outrage, humor,</strong> and <strong>affection.</strong>
            </Typography>
        </div>
    );

    return (
        <PageContainer>

        <div>
            <SlidingScale 
                question={question} 
                leftLabel="Low Social Impact" 
                rightLabel="High Social Impact" 
                handleUpdate={handleChange}
            />
            <Button variant="contained" onClick={handleNext}>Next</Button>
            <CustomConfirmationDialog
                open={showDialog}
                onClose={() => setShowDialog(false)}
                onConfirm={() => {
                    setShowDialog(false);
                    nextTask({ data: { [instanceId]: sliderValue } });
                }}
            />
                    </div>

        </PageContainer>
    );
};

const mapDispatchToProps = { nextTask };
export default connect(null, mapDispatchToProps)(SocImpactScale);


